import { Form } from 'formik';
import { MapSessionFormFields, SectionContainerContent } from '../components';
import { useSectionStyles } from './styles';

export const PresentingProblems: React.VFC = () => {
  const { classes } = useSectionStyles();

  return (
    <SectionContainerContent>
      <Form className={classes.formGroup}>
        <MapSessionFormFields namespace="presentingProblems" />
      </Form>
    </SectionContainerContent>
  );
};
